export default "/images/vendor/@coreui/icons/svg/flag/cif-lu.svg?daf6406d49f71599f774f33ef56b6842";